import { trackError } from '../utils/trackError';

export const MISSING_MKTSESSION_BOUNDARY =
  'trackPageLoadedEvent/missingMktSessionCookie';
export const MISSING_MKTSESSION_ERROR_MESSAGE =
  'The mktSession cookie is missing. The page loaded event will be tracked without it.';
export const handleMktSessionError = (mktSessionId: string | undefined) => {
  if (!mktSessionId) {
    trackError(
      new Error(MISSING_MKTSESSION_ERROR_MESSAGE),
      MISSING_MKTSESSION_BOUNDARY
    );
  }
};
